import { getUsers } from 'common/api/v1/users';

import {
    FETCH_USERS,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS,
} from '../actionTypes';
import { contactActions } from '../reducer';

export default () => (dispatch) => {
    dispatch(contactActions[FETCH_USERS]());

    getUsers()
        .then((response) =>
            dispatch(contactActions[FETCH_USERS_SUCCESS](response.data.data)),
        )
        .catch((error) =>
            dispatch(
                contactActions[FETCH_USERS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
